import { PageType } from "../types/site";
import { Vehicle } from "../types/vehicle";
import { LeadDates } from "./analitics";

export const MESSAGE_TYPE_PLUGIN_INIT = "RML_PLUGIN_INIT";
export const MESSAGE_TYPE_CONTEXT_CHANGED = "RML_CONTEXT_CHANGED";
export const MESSAGE_TYPE_GET_BUTTON_INFO = "RML_GET_BUTTON_INFO";
export const MESSAGE_TYPE_BUTTON_DATA = "RML_SET_BUTTON_DATA";
export const MESSAGE_TYPE_BUTTON_CLICK = "RML_BUTTON_CLICK";
export const MESSAGE_TYPE_SHOW_POPUP = "RML_SHOW_POPUP";
export const MESSAGE_TYPE_OPEN_PAGE = "RML_OPEN_PAGE";
export const MESSAGE_TYPE_SET_PROVIDER_DATA = "RML_SET_PROVIDER_DATA";
export const MESSAGE_TYPE_UPDATE_BUTTON = "RML_UPDATE_BUTTON";
export const MESSAGE_TYPE_INVALIDATE_BUTTONS = "RML_INVALIDATE_BUTTONS";
export const MESSAGE_TYPE_SET_FINAL_PRICE = "RML_SET_FINAL_PRICE";
export const MESSAGE_TYPE_SHOW_BUTTON = "RML_SHOW_BUTTON";
export const MESSAGE_TYPE_HANDLING_COMPLETE = "RML_COMPLETE";
export const MESSAGE_TYPE_INIT_COMPLETE = "RML_INIT_COMPLETE";
export const MESSAGE_TYPE_SET_POPUP_RESULT = "RML_SET_POPUP_RESULT";
export const MESSAGE_TYPE_POPUP_CLOSED = "RML_POPUP_CLOSED";
export const MESSAGE_TYPE_ANALYTICS = "RML_ANALYTICS";

export interface PageContext extends LeadDates {
  pageType: PageType;
  pageName: string;
  host: string;
  language?: string;
  providerData?: any;
  actionButtonData: any;
  screenWidth: number;
  screenHeight: number;
}

export interface ButtonContext extends PageContext {
  vehicle: Vehicle;
  contextId: string;
  prefetchedData: any;
}

export interface ButtonInfo {
  params?: any;
  visible?: boolean;
}
